module.exports = __webpack_public_path__ + "static/media/map.35ce811b.svg";